import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthService } from './auth.service'

/**
 * Guards the voluntary plan-selection route: a store that has already paid
 * (`active`) should never see it, so bounce it to the dashboard. Everyone else
 * (trialing, past-due, cancelled, readonly) may pick a plan there.
 */
export const paywallReverseGuard: CanActivateFn = () => {
  const auth = inject(AuthService)
  const router = inject(Router)

  const status = auth.getSubscriptionSnapshot()?.subscriptionStatus
  if (status === 'active') {
    return router.parseUrl('/home')
  }
  return true
}
